module.exports = __webpack_public_path__ + "img/r1.0628ff68.webp";